import _extends from "@babel/runtime-corejs2/helpers/extends";
import _typeof from "@babel/runtime-corejs2/helpers/typeof";
import * as React from 'react';
import Form from '@alifd/next/lib/form';
import hoistStatics from 'hoist-non-react-statics';
var Item = Form.Item;
var PropsCtx = React.createContext();

var WrappedForm = function WrappedForm(props) {
  return /*#__PURE__*/React.createElement(PropsCtx.Provider, {
    value: props
  }, /*#__PURE__*/React.createElement(Form, props));
};

var WrappedItem = function WrappedItem(props) {
  return /*#__PURE__*/React.createElement(PropsCtx.Consumer, null, function (formProps) {
    // fusion默认label靠右对齐，wind希望默认靠左对齐
    var labelTextAlign = function () {
      // Item有可能不用在Form中
      if (_typeof(formProps) !== 'object') return 'left';
      if (formProps.labelTextAlign === 'right') return 'right';
      return 'left';
    }();

    return /*#__PURE__*/React.createElement(Item, _extends({
      labelTextAlign: labelTextAlign
    }, props));
  });
};

hoistStatics(WrappedForm, Form);
hoistStatics(WrappedItem, Item);
WrappedForm.Item = WrappedItem;
export default WrappedForm;